<div *ngIf="viewState.recommendations.length > 0">
  <div class="flex" style="align-items: center; width: 100%; margin-bottom: 12px">
    <div class="header">{{ trans('RECOMMENDATIONS.RECOMMENDED_PRODUCTS') }}</div>

    <span (click)="viewAllRecommendations()" class="more-text-link large-text end-container">{{
      trans('RECOMMENDATIONS.VIEW_ALL')
    }}</span>
  </div>
  <div class="recommendations-container">
    <div class="recommendation-card">
      <div class="recommendation-header">
        <div class="recommender-text">
          <img class="avatar" src="assets/img/recommendations/avatar.png" alt="avatar" />

          {{ trans('RECOMMENDATIONS.RECOMMENDED_BY') }}
          <span class="recommender-name">{{
            viewState.recommendations[0].accountManagerName
          }}</span>
        </div>

        <div class="date">{{ viewState.recommendations[0].createdAt | date : dateFormat }}</div>
      </div>

      <div class="recommended-products">
        <div
          class="recommended-product"
          *ngFor="let product of viewState.recommendations[0].recommendedProducts.slice(0, 2)"
        >
          <div class="flex">
            <div class="recommended-product-primary-info">
              <a
                (click)="trackViewProduct(product.sku)"
                [routerLink]="['/product-details', product.id]"
              >
                <img class="product-image" [src]="product.productImage" [alt]="product.name" />
              </a>
              <div class="product-info-container">
                <a
                  (click)="trackViewProduct(product.sku)"
                  [routerLink]="['/product-details', product.id]"
                >
                  <div class="product-name">
                    {{ product.name[localeCode] || product.name.ar || product.name.en }}
                  </div>
                </a>
                <div class="prices-container">
                  <div class="product-original-price">
                    {{ trans('RECOMMENDATIONS.MIN_SELLING_PRICE') }}
                    <span class="product-original-price-value">{{ product.originalPrice }}</span>
                    <span class="currency">{{ currencyShortName }}</span>
                  </div>

                  <div *ngIf="product.recommendedAsp" class="recommended-price">
                    {{ trans('RECOMMENDATIONS.RECOMMENDED_PRICE') }}
                    <span class="recommended-price-value">{{ product.recommendedAsp }}</span>
                    <span class="recommended-price-currency">{{ currencyShortName }}</span>
                  </div>
                </div>

                <div
                  *ngIf="
                    product.confirmationRate || product.deliveryRate || product.netDeliveryRate
                  "
                  class="product-info"
                >
                  <div *ngIf="product.confirmationRate" class="product-info-item">
                    <img
                      [src]="
                        'assets/img/recommendations/stats-' +
                        (product.confirmationRate < 30
                          ? '1'
                          : product.confirmationRate < 50
                          ? '2'
                          : product.confirmationRate < 60
                          ? '3'
                          : '4') +
                        '.svg'
                      "
                      alt="confirmation-rate-stats"
                    />

                    <span class="product-info-text"
                      >{{ trans('RECOMMENDATIONS.CONFIRMATION_RATE') }}:
                      {{ product.confirmationRate }}%</span
                    >
                  </div>
                  <div *ngIf="product.deliveryRate" class="product-info-item">
                    <img
                      [src]="
                        'assets/img/recommendations/stats-' +
                        (product.deliveryRate < 20
                          ? '1'
                          : product.deliveryRate < 40
                          ? '2'
                          : product.deliveryRate < 50
                          ? '3'
                          : '4') +
                        '.svg'
                      "
                      alt="delivery-rate-stats"
                    />

                    <span class="product-info-text"
                      >{{ trans('RECOMMENDATIONS.DELIVERY_RATE') }}:
                      {{ product.deliveryRate }}%</span
                    >
                  </div>
                  <div *ngIf="product.netDeliveryRate" class="product-info-item">
                    <img
                      [src]="
                        'assets/img/recommendations/stats-' +
                        (product.netDeliveryRate < 10
                          ? '1'
                          : product.netDeliveryRate < 20
                          ? '2'
                          : product.netDeliveryRate < 30
                          ? '3'
                          : '4') +
                        '.svg'
                      "
                      alt="net-delivery-rate-stats"
                    />

                    <span class="product-info-text"
                      >{{ trans('RECOMMENDATIONS.NET_DELIVERY_RATE') }}:
                      {{ product.netDeliveryRate }}%</span
                    >
                  </div>
                </div>

                <div *ngIf="product.comment" class="product-note">
                  <img class="avatar" src="assets/img/recommendations/avatar.png" alt="avatar" />
                  <span class="product-note-text">{{ product.comment }}</span>
                </div>
              </div>
            </div>
            <div class="end-container">
              <button
                *ngIf="product.creativeLink"
                class="button"
                (click)="openCreativeLink(product.sku, product.creativeLink)"
              >
                {{ trans('RECOMMENDATIONS.PHOTOS') }}
                <img src="assets/img/recommendations/export.svg" alt="export" />
              </button>

              <button class="button" style="border-color: #dde1ed" (click)="toggleCatalog(product)">
                <img
                  style="width: 21px; height: 21px"
                  [src]="
                    product.isAddedToCatalog
                      ? 'assets/img/heart-active.svg'
                      : 'assets/img/heart.svg'
                  "
                  alt="heart"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="viewState.recommendations[0].recommendedProducts.length > 2" class="more-text">
      {{ trans('RECOMMENDATIONS.MORE_PRODUCTS') }}
      <span (click)="viewAllRecommendations()" class="more-text-link">{{
        trans('RECOMMENDATIONS.VIEW_ALL')
      }}</span>
    </div>
  </div>
</div>
